import { Component, h } from "preact";
import Uploader from "../../uploader";
import { IReactConfiguration, IOption } from "../../../typings";
import EventController from "../../../shared/controller/event-controller";
import OutputController from "../../../shared/controller/output-controller";
import TemplateController from "../../../shared/controller/template-controller";
import UnitSystemController from "../../../shared/controller/unit-system-controller";

interface ILabelCommentsComponentState {
  comments: string;
}

export default class LabelCommentsComponent extends Component<
  ILabelCommentsComponentProps,
  ILabelCommentsComponentState
> {
  constructor(props: ILabelCommentsComponentProps) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  componentDidMount(): void {
    this.updateCommentsOutputValue();
  }

  updateCommentsOutputValue(): void {
    const comments: string = this.props.outputController.getValue([
      "comments",
      "comments",
    ]);
    this.setState({ comments });
  }

  onChange(e: any): void {
    const target: HTMLInputElement = e.currentTarget;
    const comments: string = target.value;

    this.props.outputController
      .setValue(["comments", "comments"], comments)
      .then(() => {
        this.updateCommentsOutputValue();
      })
      .catch(() => {});
  }

  render(): JSX.Element {
    return (
      <div>
        <p className="mb-2">{this.props.option.meta.fields.placeholder}</p>
        <textarea
          className="w-full"
          onChange={this.onChange}
          value={this.state.comments}
        >
          {this.state.comments}
        </textarea>
      </div>
    );
  }
}

interface ILabelCommentsComponentProps {
  main: Uploader;
  conf: IReactConfiguration;
  option: IOption;

  eventController: EventController;
  outputController: OutputController;
  templateController: TemplateController;
  unitSystemController: UnitSystemController;
}
